import { render } from "./rqzjManager.vue?vue&type=template&id=4e729fa3"
import script from "./rqzjManager.vue?vue&type=script&lang=js"
export * from "./rqzjManager.vue?vue&type=script&lang=js"

import "./rqzjManager.vue?vue&type=style&index=0&id=4e729fa3&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__